export function initTestimonialsSwiper() {
  // Testimonials Swiper
  const $testimonialSwiper = window.jQuery('.buckup-testimonials-container');

  if ($testimonialSwiper.length && window.Swiper) {
    new window.Swiper('.buckup-testimonials-container.swiper-container', {
      // modules are already configured in app.js via Swiper.use()
      slidesPerView: 3,
      centeredSlides: true,
      initialSlide: 2,
      loop: true,
      speed: 1500,
      autoplay: false,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        },
      },
    });
  }
}